<script setup lang="ts">
import type {ImgHTMLAttributes} from "@vue/runtime-dom";
import FallbackImage from '../../../images/no-image.png'
import {tw} from "../../utils/tailwind.ts";

interface ImageWithFallbackProps {
    src: ImgHTMLAttributes['src']
    alt: ImgHTMLAttributes['alt']
    class?: ImgHTMLAttributes['class']
    loading?: ImgHTMLAttributes['loading']
    fallback?: string
}

const props = withDefaults<ImageWithFallbackProps, ImageWithFallbackProps>(
    defineProps<ImageWithFallbackProps>(),
    {
        loading: 'lazy',
        fallback: FallbackImage,
    }
)

const handleError = (event: ErrorEvent) => {
    (event.target as HTMLImageElement).src = props.fallback
}
</script>

<template>
    <img
        :src="src"
        :alt="alt"
        :class="tw('object-cover w-full h-full', props.class)"
        @error.once="handleError"
    />
</template>
